export const findPages = ( apolloState ) => {
  if( !apolloState ){
    return [];
  }
  return Object.entries( apolloState )
    .filter( ( [key] ) => key.startsWith( 'Page(' ) )
    .map( ( [key, value] ) => ( {
      ...value,
      __key: key
    } ) );
};

export const isModuleInContent = ( node, moduleId ) => {
  if( !node || typeof node !== 'object' ){
    return false;
  }

  if( node.id === moduleId ){
    return true;
  }

  if( Array.isArray( node.modules ) ){
    for ( const module of node.modules ){
      if( isModuleInContent( module, moduleId ) ){
        return true;
      }
    }
  }

  return Object.entries( node ).some(
    ( [key, val] ) =>
      key !== 'modules' &&
      typeof val === 'object' &&
      isModuleInContent( val, moduleId )
  );
};

export const crawlForModules = (
  value,
  getNodeId
) => {
  if(
    !value ||
    typeof value !== 'object'
  ){
    return [];
  }

  const traverse = ( node ) => {
    if(
      !node ||
      typeof node !== 'object'
    ){
      return null;
    }

    const {
      id,
      type,
      moduleName,
      modules,
      debugData,
      ...rest
    } = node;

    const hasLabel =
      typeof moduleName === 'string' ||
      typeof type === 'string';

    let currentNode = null;

    if( hasLabel ){
      currentNode = {
        id: id ?
          `${id}_${getNodeId()}` :
          getNodeId(),
        label: `${debugData?.label || ''}::${moduleName || type}`,
        disableAmplienceLink:
          id === 'n/a' ?
            true :
            !debugData?.label,
        moduleData: {
          ...rest,
          id,
          moduleName,
          modules,
          type
        },
        children: []
      };
    }

    if( Array.isArray( modules ) ){
      modules.forEach( ( child ) => {
        const childNode =
          traverse( child );

        if(
          childNode &&
          currentNode
        ){
          currentNode.children.push(
            childNode
          );
        }
      } );
    }

    Object.values( rest ).forEach(
      ( val ) => {
        if(
          typeof val === 'object' &&
          !Array.isArray( val )
        ){
          const nestedNode =
            traverse( val );

          if(
            nestedNode &&
            currentNode
          ){
            currentNode.children.push(
              nestedNode
            );
          }
        }
      }
    );

    return currentNode;
  };

  const root = traverse( value );

  return root ? [root] : [];
};

export const extractModuleTreesFromPages = (
  apolloState
) => {
  if( !apolloState ){
    return { content: undefined };
  }
  const pages = findPages(
    apolloState.ROOT_QUERY || {}
  );

  const pageObject =
    pages.length > 0 ?
      pages[0] :
      null;

  return {
    content: pageObject?.content
  };
};

export const findNodeById = (
  nodes,
  id
) => {
  if( !Array.isArray( nodes ) ){
    return null;
  }
  for ( const n of nodes ){
    if( n.id === id ){
      return n;
    }

    if(
      n.children &&
      n.children.length >
        0
    ){
      const hit = findNodeById(
        n.children,
        id
      );

      if( hit ){
        return hit;
      }
    }
  }

  return null;
};

export const findNodeByContentId = (
  nodes,
  contentId
) => {
  if( !Array.isArray( nodes ) ){
    return null;
  }
  for ( const n of nodes ){
    if(
      n.moduleData?.id === contentId
    ){
      return n;
    }

    if(
      n.children &&
      n.children.length >
        0
    ){
      const hit =
        findNodeByContentId(
          n.children,
          contentId
        );

      if( hit ){
        return hit;
      }
    }
  }

  return null;
};
